<template>
  <section class="loader-box">
    <div class="words">
      <span>
        <img
          class="img-loading"
          src="@/assets/sunset-loading.svg"
          alt="Icone loading"
        />
        <p class="texto-carregando">{{ $t('carregando') + '.' }}</p>
      </span>
      <span>
        <img
          class="img-loading"
          src="@/assets/beach-hut-loading.svg"
          alt="Icone loading"
        />
        <p class="texto-carregando">{{ $t('carregando') + '..' }}</p>
      </span>
      <span>
        <img
          class="img-loading"
          src="@/assets/kiteboarding-loading.svg"
          alt="Icone loading"
        />
        <p class="texto-carregando">{{ $t('carregando') + '...' }}</p>
      </span>
      <span>
        <img
          class="img-loading"
          src="@/assets/beach-hut-loading.svg"
          alt="Icone loading"
        />
        <p class="texto-carregando">{{ $t('carregando') + '....' }}</p>
      </span>
    </div>
  </section>
</template>

<script>
export default {
  name: 'LoadingBox',
};
</script>

<style>
@keyframes wordFade {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  10% {
    opacity: 1;
    transform: translateY(0);
  }
  25% {
    opacity: 1;
    transform: translateY(0);
  }
  35% {
    opacity: 0;
    transform: translateY(-10px);
  }
  100% {
    opacity: 0;
  }
}
</style>

<style scoped>
.loader-box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 120px;
  height: 200px;
  font-size: 2rem;
  font-weight: 600;
}

.words {
  position: relative;
  height: 100px;
  width: 200px;
  overflow: hidden;
}

.words span {
  position: absolute;
  left: 0;
  opacity: 0;
  animation: wordFade 4s infinite;
}

.img-loading {
  width: 42px;
}

.texto-carregando {
  margin-top: 12px;
}

.words span:nth-child(1) {
  animation-delay: 0s;
}
.words span:nth-child(2) {
  animation-delay: 1s;
}
.words span:nth-child(3) {
  animation-delay: 2s;
}
.words span:nth-child(4) {
  animation-delay: 3s;
}
@media (max-width: 640px) {
  .loader-box {
    height: 140px;
    font-size: 1.2rem;
    justify-content: center;
  }

  .words {
    width: 160px;
    height: 80px;
  }

  .img-loading {
    width: 32px;
  }

  .texto-carregando {
    font-size: 0.9rem;
    text-align: center;
  }
}
@media (min-width: 641px) and (max-width: 1023px) {
  .loader-box {
    height: 180px;
    font-size: 1.5rem;
  }

  .words {
    width: 180px;
    height: 90px;
  }

  .img-loading {
    width: 36px;
  }

  .texto-carregando {
    font-size: 1rem;
  }
}
</style>
